<template>
    <div class="offcanvas_backdrop" @click="CloseModal"></div>
</template>

<script setup>
import useToggleModal from '../../composables/useToggleModal'
const { toggleModal } = useToggleModal()

const emits = defineEmits(['OnCloseCanvas'])
const props = defineProps({
    isToggle: {
        type: Boolean,
        default: true
    }
})
const CloseModal = ()=>{
    if (props.isToggle) {
        toggleModal();
    }
    emits('OnCloseCanvas')
}


</script>

<style scoped>
.offcanvas_backdrop {
    @apply w-screen h-screen fixed top-0 left-0 z-20 bg-[rgba(0,0,0,0.1)];
}
</style>
